import React, { useState, useEffect } from "react";
import { EmailBuilderV2 } from "@/components/email-builder/EmailBuilderV2";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { sendNewsletter } from "@/components/sections/admin/newsletter/newsletterService";

export default function AdminEmailBuilder() {
  const { toast } = useToast();
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    getUser();
  }, []);

  const handleSaveTemplate = async (template: any) => {
    if (!user) {
      toast({
        title: "Error",
        description: "You must be logged in to save templates.",
        variant: "destructive",
      });
      return;
    }

    try {
      const { error } = await supabase
        .from('email_templates')
        .insert({
          user_id: user.id,
          name: template.name,
          subject: template.subject,
          html_content: template.html_content,
          json_content: template.json_content,
          category: 'newsletter',
        });

      if (error) throw error;

      toast({
        title: "Success",
        description: "Template saved successfully!",
      });
    } catch (error) {
      console.error('Error saving template:', error);
      toast({
        title: "Error",
        description: "Failed to save template. Please try again.",
        variant: "destructive",
      });
    }
  };

  const handleSendEmail = async (email: any) => {
    try {
      const result = await sendNewsletter({
        subject: email.subject,
        content: email.html_content,
      });

      if (result.success) {
        toast({
          title: "Success",
          description: "Email sent successfully!",
        });
      } else {
        throw new Error(result.error || "Failed to send email");
      }
    } catch (error) {
      console.error('Error sending email:', error);
      toast({
        title: "Error",
        description: "Failed to send email. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <EmailBuilderV2
        onSave={handleSaveTemplate}
        onSend={handleSendEmail}
      />
    </div>
  );
}